import registrationContractExpiredDictionary from '@features/registration/shared/ui/contract-expired/i18n/ru/contract-expired.dic.json';

export const registrationContractExpired = {
  REGISTRATION_CONTRACT_EXPIRED: registrationContractExpiredDictionary,
};

export const registrationContractExpiredNamespaces = Object.keys(
  registrationContractExpired
);
